import React from 'react';
import TableSearch from '@rio-cloud/rio-uikit/lib/es/TableSearch';
import { Divider } from '@rio-cloud/rio-uikit';
import DeviceTypeSelect from '~/features/base/components/forms/DeviceTypeSelect';
import DeliverableTypeSelect from '~/features/base/components/forms/DeliverableTypeSelect';
import { FormattedMessage, useIntl } from 'react-intl';
import { ALL } from '~/features/base/constants/filterOptions';

interface FilterSearchBarProps {
  searchTerm: string | undefined;
  setSearchTerm: (term: string) => void;
  deviceTypeFilter: any;
  setDeviceTypeFilter: (filter: any) => void;
  deliverableTypeFilter: string;
  setDeliverableTypeFilter: (filter: string) => void;
}

const FilterSearchBar: React.FC<FilterSearchBarProps> = ({
  searchTerm,
  setSearchTerm,
  deviceTypeFilter,
  setDeviceTypeFilter,
  deliverableTypeFilter,
  setDeliverableTypeFilter
}) => {
  const intl = useIntl();
  return (
    <div className={'display-flex flex-row margin-bottom-25'}>
      <TableSearch
        className={'width-300 align-self-center'}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e as string)}
        placeholder={intl.formatMessage({ id: 'intl-msg:campaign:search' })}
      />
      <Divider vertical className='padding-y-3'/>
      <div className={'display-flex flex-row gap-15'}>
        <span className={'align-self-center title'}>
          <FormattedMessage id={'intl-msg:filterBy'}/>
        </span>
        <div className={'align-self-center'}>
          <DeviceTypeSelect 
            label={<FormattedMessage id={'intl-msg:deviceType'}/>} 
            withLabel
            withAllOption
            value={deviceTypeFilter.value}
            onChange={setDeviceTypeFilter}
          />
        </div>
        <div className={'align-self-center'}>
          <DeliverableTypeSelect 
            withAllOption 
            withLabel 
            value={deliverableTypeFilter}
            label={<FormattedMessage id={'intl-msg:deliverableType'}/>}
            onChange={setDeliverableTypeFilter}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterSearchBar;